import React, { useEffect, forwardRef } from "react";
import FooterWrapper from "../../../common/components/footerWrapper/footerWrapper";
import styles from "./footer.scss";
// import ProductActions from "../../../common/components/productActions/productActions";
import ProductActions from "@tw/shared-ui-components/lib/components/productActions/productActions";
import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { getPageDetails } from "../../../common/utils/helper";
import { PAGES } from "@tw/shared-ui-components/lib/utils/analytics";
import NoTranslate from "../../../common/components/notranslate/noTranslate";

const Footer = forwardRef(
  ({ productInfo, productStatusObj, onSuccess, handleQuantityChange, btnLoading, initialQuantity }, ref) => {
    if (!productInfo) return null;
    const [totalPrice, setTotalPrice] = React.useState();

    const { productBrand, productName, price } = productInfo;

    const intlNumberFormatter = new Intl.NumberFormat("en-US");
    const onQuantityChange = (quan) => {
      setTotalPrice((quan ? quan : 1) * price)
      handleQuantityChange(quan)
    };

    // To handle notify me button click
    const onNotifyMeHandle = () => {
      onSuccess && onSuccess();
    };

    useEffect(() => {
      setTotalPrice(parseInt(productInfo?.price));
    }, [productInfo?.price]);
    return (
      <FooterWrapper ref={ref}>
        {/* <p id="show-warn"></p> */}
        <div className={styles["details-div"]}>
          <h2>
            {productBrand ? productBrand + " " : ""}
            {productName}
          </h2>
          <NoTranslate>
            {"$" + " " + intlNumberFormatter.format(totalPrice)}
          </NoTranslate>
        </div>
        <div className={styles["cart-btns"]}>
          <ProductActions
            initialQuantity={initialQuantity}
            productInfo={productInfo}
            productStatusObj={productStatusObj}
            onNotifyMeHandle={onNotifyMeHandle}
            onSuccess={onSuccess}
            onQuantityChange={onQuantityChange}
            updateCartDetails={updateCartDetails}
            pageDetails={getPageDetails(productInfo.categories?.[0], PAGES.pdp)}
            btnLoading={btnLoading}
          />
        </div>
      </FooterWrapper>
    );
  }
);

export default Footer;
